var DEFAULT_NAVIGATION_CONTAINER_ID="navigation";export{DEFAULT_NAVIGATION_CONTAINER_ID as D};